"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var _Review = _interopRequireDefault(require("../../records/Review"));

var _dummyReviews = require("../../constants/reviews/dummyReviews");

var _CompanySize = require("../../constants/reviews/CompanySize");

var ReviewerInfo = function ReviewerInfo(_ref) {
  var inline = _ref.inline,
      review = _ref.review;
  var avatarUrl = review.avatarUrl,
      showAvatar = review.showAvatar,
      displayName = review.displayName,
      fullName = review.fullName,
      industry = review.industry,
      employees = review.employees;
  var renderedName = displayName || fullName;
  var renderedReviewerInfoText = (0, _react.useMemo)(function () {
    var showEmployees = employees !== _CompanySize.PREFER_NOT_TO_SAY;
    var showIndustry = industry !== _CompanySize.PREFER_NOT_TO_SAY;

    var employeeString = _Review.default.toEmployeeString(employees);

    if (inline) {
      return _react.default.createElement(_UIList.default, {
        inline: true,
        use: "inline-divided"
      }, _react.default.createElement(_H.default, {
        className: "m-bottom-0"
      }, renderedName), showIndustry && _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: "ecosystemMarketplaceCore.reviews.industry." + industry
      })), showEmployees && _react.default.createElement(_Small.default, null, employeeString));
    }

    return _react.default.createElement(_UIFlex.default, {
      direction: "column"
    }, _react.default.createElement(_H.default, {
      className: "m-bottom-1"
    }, renderedName), showIndustry && _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "ecosystemMarketplaceCore.reviews.industry." + industry
    })), showEmployees && _react.default.createElement(_Small.default, null, employeeString));
  }, [inline, renderedName, industry, employees]);
  var renderedUserAvatar = (0, _react.useMemo)(function () {
    var imageSize = inline ? '24' : '48';
    var avatarSize = inline ? 'xs' : 'md';

    if (avatarUrl && showAvatar) {
      return _react.default.createElement(_UIImage.default, {
        shape: "circle",
        src: avatarUrl,
        height: imageSize,
        width: imageSize
      });
    } else {
      return _react.default.createElement(_UIAvatar.default, {
        type: "contact",
        size: avatarSize
      });
    }
  }, [inline, avatarUrl, showAvatar]);
  return _react.default.createElement(_UIMediaObject.default, {
    align: "center",
    itemLeft: renderedUserAvatar
  }, renderedReviewerInfoText);
};

ReviewerInfo.propTypes = {
  inline: _propTypes.default.bool,
  review: _propTypes.default.instanceOf(_Review.default).isRequired
};
ReviewerInfo.defaultProps = {
  inline: false,
  review: _dummyReviews.review2
};
var _default = ReviewerInfo;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/ReviewerInfo.js
// module id = 286
// module chunks = 209 210 211 212